import React, { useEffect, useState } from "react";
import { Colors } from "../palettes/colorPalette";
import { GameClient } from "../gameClient";
import { Modal } from "./Modal";
import { GameElement } from "../../../shared/gameElementTypes";
import { CellDescription } from "./cellDescription";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Sound } from "../../../shared/sound";

interface RewardChooserProps {
	choices: GameElement[]
}

declare var gameClient: GameClient;

export const RewardChooser = (props: RewardChooserProps) => {

	let [hovered, setHovered] = React.useState(-1);
	let [hidden, setHidden] = React.useState(false);

	const chooseReward = (i: number) => {
		gameClient.chooseReward(i);
		gameClient.playUISound(Sound.ButtonClick);
	}

	const hide = () => {
		setHidden(!hidden);
	}

	return (
		<Modal isOpen={true} noBackground={true} hasCloseBtn={false}>
			<div style={{ display: "flex", flexDirection: "row", alignContent: "center", justifyContent: "center" }}>
				<h1 style={{ fontWeight: "bolder", color: Colors.UIIncomingTabText, textShadow: "1px 1px 1px " + Colors.UITextAndBorders, margin: "0px" }}>Triple!</h1>
				<FontAwesomeIcon style={{
					position: 'absolute',
					top: '8vh',
					right: '4vh',
					cursor: 'pointer',
					color: Colors.UIIncomingTabText
				}} icon={faTimesCircle} onClick={hide} />
			</div>
			<div style={{ display: "flex", flexDirection: "row", alignContent: "center", justifyContent: "center", marginBottom: "50px" }}>
				<div style={{ fontWeight: "normal", color: Colors.UIIncomingTabText, textShadow: "1px 1px 1px " + Colors.UITextAndBorders }}>Choose a Reward Cell:</div>
			</div>
			<div style={{
				width: "100%",
				height: "50%",
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-around",
				opacity: `${hidden === false ? 1 : 0.1}`,
			}

			}
			>
				{props.choices.map((choice, i) => {
					return <div
						key={i}
						style={{
							transform: `scale(${hovered === i ? 1.1 : 1})`,
							zIndex: `${hovered === i ? 1 : 0}`,
							opacity: `${hovered === i || hovered === -1 ? 1 : 0.3}`,
							transition: "all 0.15s ease-in-out",
						}}
						onMouseEnter={() => {
							if (hidden) {
								setHidden(false);
							}
							setHovered(i)
						}}
						onMouseLeave={() => setHovered(-1)}
						onClick={() => chooseReward(i)}
					>
						<CellDescription isReward={true} element={choice} showTooltips={hovered === i} fixedHeight="23em"></CellDescription>
					</div>
				})}
			</div>
		</Modal>
	)
}